import { CancelReason } from '../../models/CancelReason';
import type { Subscription } from '../../Subscription';
import { SubscriptionUpdatesActionType } from './actionTypes';

// cancel

export const cancelDigitalSub = (
  sub: Subscription,
  reason: CancelReason = CancelReason.Unspecified,
) => ({
  type: SubscriptionUpdatesActionType.SubsDigCancelRequest,
  payload: {
    sub,
    reason,
  },
});

export const cancelDigSuccess = () => ({
  type: SubscriptionUpdatesActionType.SubsDigCancelSuccess,
});

export const cancelDigFailure = () => ({
  type: SubscriptionUpdatesActionType.SubsDigCancelFailure,
});

export const clearUpdateStatus = () => ({
  type: SubscriptionUpdatesActionType.SubsDigUpdatesClear,
});

// reactivate

export const reactivateSubscription = (sub: Subscription) => ({
  type: SubscriptionUpdatesActionType.ReactivateRequest,
  payload: sub.id,
});

export const reactivateSuccess = () => ({
  type: SubscriptionUpdatesActionType.ReactivateSuccess,
});

export const reactivateFailure = () => ({
  type: SubscriptionUpdatesActionType.ReactivateFailure,
});
